import { render, staticRenderFns } from "./Arrivals.vue?vue&type=template&id=02531fdd&scoped=true"
import script from "./Arrivals.vue?vue&type=script&lang=js"
export * from "./Arrivals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02531fdd",
  null
  
)

export default component.exports